import React from 'react'
import PropTypes from 'prop-types'
import { Row } from '@sainsburys-tech/bolt'
import UGSliderLayout from '../../../helpers/UGSliderLayout'

/**
 UG005 is the Universal Grid for rendering 1-6 Hero components in a slider on all viewports.
* */
const UG005 = ({ children, included, consumingGridType, onSlideChange }) => {
  const maxLength = 6
  const childrenArray = Array.isArray(children) ? children : [children]
  const numberOfComponents = included ? included.length : childrenArray.length

  if (numberOfComponents === 0) return null

  const filteredIncludes = included?.slice(0, maxLength)
  const filteredChildren = childrenArray?.slice(0, maxLength)

  return (
    <Row gutterValue={0} data-test='ug005-container'>
      <UGSliderLayout
        onSlideChange={onSlideChange}
        childrenArray={filteredChildren}
        included={filteredIncludes}
        consumingGridType={consumingGridType}
      />
    </Row>
  )
}

UG005.propTypes = {
  /** Child components passed down from consumer app */
  children: PropTypes.node,
  /** name of the grid passed down to child components. defaults to UG005 */
  consumingGridType: PropTypes.string,
  /** Array of child components to be rendered inside the grid */
  included: PropTypes.arrayOf(PropTypes.shape),
  /** Function to be called when the slide changes */
  onSlideChange: PropTypes.func
}

UG005.defaultProps = {
  consumingGridType: 'ug005',
  onSlideChange: () => {}
}

export default UG005
